"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _class, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var PropTypes = require("prop-types");

var React = require("react");

var classnames = require("classnames");

var moment = require("moment-range");

var Cell = require("./Cell");

var ViewHeader = require("./ViewHeader");

var CalendarUtils = require("./Utils.js");

module.exports = (_temp = _class = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(_class, _React$Component);

  var _super = _createSuper(_class);

  function _class() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, _class);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "years", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "next", function () {
      var date = _this.props.date.clone().add(10, "years"); // Get nearest year that falls in range


      date = CalendarUtils.getNearestInRange(date, _this.props.dateRange, "years");

      _this.props.onSetDate(date);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prev", function () {
      var date = _this.props.date.clone().subtract(10, "years"); // Get nearest year that falls in range


      date = CalendarUtils.getNearestInRange(date, _this.props.dateRange, "years");

      _this.props.onSetDate(date);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rangeCheck", function (currYear) {
      if (_this.years.length === 0) {
        return false;
      }

      return _this.years[0].label <= currYear && _this.years[_this.years.length - 1].label >= currYear;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getNow", function () {
      var now = moment();

      if (_this.props.utcOffset) {
        now.utcOffset(_this.props.utcOffset);
      }

      return now;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getYears", function () {
      var _context2;

      var now = _this.props.date,
          start = now.clone().subtract(5, "year"),
          end = now.clone().add(6, "year"),
          currYear = now.year(),
          items = [],
          inRange = _this.rangeCheck(currYear);

      if (_this.years.length > 0 && inRange) {
        return _this.years;
      }

      _this.getNow().range(start, end).by("years", (0, _bind.default)(_context2 = function _context2(year) {
        items.push({
          label: year.format("YYYY"),
          curr: currYear === year.year(),
          outOfRange: !CalendarUtils.inDateRange(year, this.props.dateRange, "years")
        });
      }).call(_context2, (0, _assertThisInitialized2.default)(_this)));

      _this.years = items;
      return items;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cellClick", function (e) {
      var year = (0, _parseInt2.default)(e.target.innerHTML, 10);

      var date = _this.props.date.clone().year(year); // Check year falls in range


      if (CalendarUtils.inDateRange(date, _this.props.dateRange, "years")) {
        // Get nearest month within year that falls in range
        date = CalendarUtils.getNearestInRange(date, _this.props.dateRange, "months");

        _this.props.onPrevView(date);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(_class, [{
    key: "render",
    value: function render() {
      var years = this.getYears();
      var currYear = this.props.date.year();
      var yearsCells = (0, _map.default)(years).call(years, function (item, i) {
        var className = classnames({
          year: true,
          current: (0, _parseInt2.default)(item.label) === currYear,
          disabled: item.outOfRange
        });
        return /*#__PURE__*/React.createElement(Cell, {
          "data-id": "years-cell-" + item.label,
          value: item.label,
          className: className,
          key: i
        });
      });
      var currentDate = [years[0].label, years[years.length - 1].label].join("-");

      var _ref = this.props.dateRange || {},
          startDate = _ref.startDate,
          endDate = _ref.endDate;

      return /*#__PURE__*/React.createElement("div", {
        "data-id": this.props["data-id"],
        className: "years-view"
      }, /*#__PURE__*/React.createElement(ViewHeader, {
        onPrev: this.prev,
        onNext: this.next,
        prevDisabled: startDate && (0, _parseInt2.default)(years[0].label) - 1 < startDate.year(),
        nextDisabled: endDate && (0, _parseInt2.default)(years[years.length - 1].label) + 1 > endDate.year(),
        data: currentDate
      }), /*#__PURE__*/React.createElement("div", {
        className: "years",
        onClick: this.cellClick,
        "data-id": "years-view_cell"
      }, yearsCells));
    }
  }]);
  return _class;
}(React.Component), (0, _defineProperty2.default)(_class, "propTypes", {
  "data-id": PropTypes.string,
  date: PropTypes.object,
  onSetDate: PropTypes.func,
  onPrevView: PropTypes.func
}), (0, _defineProperty2.default)(_class, "defaultProps", {
  "data-id": "years-view"
}), _temp);